// skipToMainHref.js — THE SKIP LINK FOLLOWS THE OPEN WINDOW.
//
// The shell's first tab stop (app.js SkipToMain) jumps past the chrome to the
// content on screen. With the primary PageSlot pane open over the page, that
// content is the window, not the page behind it, so the link targets the pane:
// canvas components/PageSlot.js names each pane `page-slot-pane-<slot key>`,
// and the pane's `tabindex: -1` lets the browser's fragment jump focus it —
// the next Tab lands on the window's first control. With no pane open the
// link targets the route's main landmark (`#main-content`,
// functions/anchorMainContent.js).
//
// The primary pane is open while `_canvasSlot` holds its route — PageSlot's
// own gate (`_slotPane` hide). A close or a minimize clears the key or moves
// the split's second route into it (PageSlot `_closeSlot` / `_minimizeSlot`),
// so the second pane never holds a route alone, and the split placeholder
// (`_slotSplitIntent`, no route yet) belongs to the header search, which holds
// the keyboard. The key is read up front (a reactive caller: the link's
// `href`, re-rendered on `subscribeTo: ['_canvasSlot']`).
export const skipToMainHref = function skipToMainHref(root) {
  const r = root && typeof root === 'object' ? root : {}
  const route = r._canvasSlot
  return route ? '#page-slot-pane-_canvasSlot' : '#main-content'
}
